const endpoint = "https://nmpb.cuba-lv.com"
const cpoint = "https://central-backend.cuba-lv.com"
const mediapoint = "https://s3-media.cuba-lv.com"
const startpoint = `${cpoint}/`
const gamePlace = { studio: "tbilisi", room: "po2-room" }

export { endpoint, mediapoint, startpoint, gamePlace }
